
import { defineComponent, PropType } from 'vue'
import { RepositoryScaTargetReportItem } from '~/types/types'
import { getPackageManagerIcon } from '~/utils/dependencies'
import { extractHashId } from '~/utils/hashId'
import { shortenLargeNumber } from '~/utils/string'

type Target = Pick<
  RepositoryScaTargetReportItem,
  | 'id'
  | 'repository'
  | 'packageManager'
  | 'manifestPath'
  | 'lockfilePath'
  | 'criticalSeverityVulnerabilityCount'
  | 'highSeverityVulnerabilityCount'
  | 'mediumSeverityVulnerabilityCount'
  | 'lowSeverityVulnerabilityCount'
>

export default defineComponent({
  name: 'ScaTargetListItem',
  props: {
    target: {
      type: Object as PropType<Target>,
      required: true
    },
    routeProvider: {
      type: String,
      required: true
    },
    routeOwner: {
      type: String,
      required: true
    }
  },
  methods: {
    getPackageManagerIcon,
    extractHashId,
    vulnerabilityCounts(target: Target) {
      const countArray = []

      if (target.criticalSeverityVulnerabilityCount)
        countArray.push({
          icon: 'severity-critical',
          count: shortenLargeNumber(target.criticalSeverityVulnerabilityCount),
          color: 'text-cherry'
        })

      if (target.highSeverityVulnerabilityCount)
        countArray.push({
          icon: 'severity-high',
          count: shortenLargeNumber(target.highSeverityVulnerabilityCount),
          color: 'text-amber'
        })

      if (target.mediumSeverityVulnerabilityCount)
        countArray.push({
          icon: 'severity-medium',
          count: shortenLargeNumber(target.mediumSeverityVulnerabilityCount),
          color: 'text-honey'
        })

      if (target.lowSeverityVulnerabilityCount)
        countArray.push({
          icon: 'severity-low',
          count: shortenLargeNumber(target.lowSeverityVulnerabilityCount),
          color: 'text-vanilla-400'
        })

      return countArray
    }
  }
})
